(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westmere-header"]) return;
  try {
    
  if (!customElements.get('westmere-navigation')) customElements.define('westmere-navigation',class extends HTMLElement {
    async connectedCallback(){
      this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
      const {StandardEvents}=await import('@shopify/events'); this.setAttribute('data-enhanced',''); document.addEventListener(StandardEvents.cartLinesUpdate,event=>{event.promise?.then(({cart})=>{if(!cart||!this.isConnected)return;const count=cart.totalQuantity;const link=this.querySelector('.wm-cart');const badge=link.querySelector('[data-cart-count]');badge.textContent=String(count);badge.hidden=count===0;link.setAttribute('aria-label',link.dataset.cartLabel.replace('__COUNT__',String(count)));}).catch(()=>{});},options);
      const toggle=this.querySelector('.wm-nav-toggle');const menus=[...this.querySelectorAll('.wm-shop-menu')];
      const close=(restore=false)=>{const active=menus.find(menu=>menu.open);menus.forEach(menu=>menu.open=false);if(restore&&active)active.querySelector('summary').focus();};
      const mobileClose=()=>{this.removeAttribute('data-mobile-open');toggle.setAttribute('aria-expanded','false');};
      toggle.addEventListener('click',()=>{const open=toggle.getAttribute('aria-expanded')!=='true';toggle.setAttribute('aria-expanded',String(open));this.toggleAttribute('data-mobile-open',open);if(!open)close();},options);
      menus.forEach(menu=>{
        menu.addEventListener('toggle',()=>{if(menu.open)menus.forEach(other=>{if(other!==menu)other.open=false;});},options);
        menu.querySelector('summary').addEventListener('pointerenter',event=>{if(event.pointerType==='mouse'&&matchMedia('(min-width:901px) and (hover:hover)').matches){clearTimeout(this.timer);menus.forEach(other=>other.open=other===menu);}},options);
      });
      this.addEventListener('pointerenter',()=>clearTimeout(this.timer),options);
      this.addEventListener('pointerleave',()=>{if(matchMedia('(min-width:901px) and (hover:hover)').matches)this.timer=setTimeout(()=>{if(!this.contains(document.activeElement))close();},180);},options);
      this.addEventListener('keydown',event=>{if(event.key==='Escape'){event.preventDefault();if(menus.some(menu=>menu.open))close(true);else{mobileClose();toggle.focus();}}},options);
      this.addEventListener('focusout',()=>{queueMicrotask(()=>{if(!this.contains(document.activeElement)){close();mobileClose();}});},options);
      document.addEventListener('pointerdown',event=>{if(!this.contains(event.target)){close();mobileClose();}},options);
      this.querySelectorAll('nav a').forEach(link=>link.addEventListener('click',()=>{close();mobileClose();},options));
    }
    disconnectedCallback(){this.abort?.abort();clearTimeout(this.timer);}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westmere-hero"] && !Shopify.designMode) return;
  try {
    
  if(!customElements.get('westmere-index'))customElements.define('westmere-index',class extends HTMLElement{
    connectedCallback(){if(this.ready)return;this.ready=true;const list=this.querySelector('[role="tablist"]');const media=matchMedia('(max-width:900px)');const orient=()=>list.setAttribute('aria-orientation',media.matches?'horizontal':'vertical');orient();media.addEventListener('change',orient);const tabs=[...this.querySelectorAll('[role="tab"]')];const panels=[...this.querySelectorAll('[role="tabpanel"]')];const choose=(index,focus=false)=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index});if(focus)tabs[index].focus()};tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>choose(index));tab.addEventListener('keydown',event=>{let next=index;if(['ArrowRight','ArrowDown'].includes(event.key))next=(index+1)%tabs.length;else if(['ArrowLeft','ArrowUp'].includes(event.key))next=(index+tabs.length-1)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();choose(next,true)})});this.addEventListener('shopify:block:select',event=>{const index=tabs.findIndex(tab=>tab.contains(event.target)||tab===event.target);if(index>=0)choose(index)})}
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["westmere-our-story"]) return;
  try {
    
  document.querySelectorAll('.wm-story-gallery').forEach(gallery=>{
    const dialog=gallery.querySelector('dialog');
    gallery.querySelectorAll('[data-gallery-image]').forEach(link=>link.addEventListener('click',event=>{
      event.preventDefault();const source=link.querySelector('img');const image=dialog.querySelector('img');image.src=link.href;image.alt=source.alt;dialog.querySelector('p').textContent=source.alt;dialog.showModal();
    }));
    dialog.querySelector('[data-gallery-close]').addEventListener('click',()=>dialog.close());
    dialog.addEventListener('click',event=>{if(event.target===dialog){const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)dialog.close();}});
  });

  } catch(e) { console.error(e); }
})();
})();
